const emoTextList = [
	'😀', '😁', '😂', '🤣', '😃', '😄', '😅', '😆', '😉', '😊',
	'🙂', '🙃', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛',
	'😜', '🤪', '🤨', '🧐', '🤓', '😎', '🥳', '😤', '😭', '😡',
	'😱', '😨', '😰', '🤯', '😴', '🤗', '🤔', '🙄', '😬', '🤐',
	'🤝', '🙏', '👍', '👎', '👏', '🙌', '👀', '💪', '🔥', '✨',
	'💯', '🎉', '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍'
];

// Kept for backward compatibility when rendering old messages that used #汉字; format
const oldEmoTextList = ['憨笑', '媚眼', '开心', '坏笑', '可怜', '爱心', '笑哭', '拍手', '惊喜', '打气',
	'大哭', '流泪', '饥饿', '难受', '健身', '示爱', '色色', '眨眼', '暴怒', '惊恐',
	'思考', '头晕', '大吐', '酷笑', '翻滚', '享受', '鼻涕', '快乐', '雀跃', '微笑',
	'贪婪', '红心', '粉心', '星星', '大火', '眼睛', '音符', "叹号", "问号", "绿叶",
	"燃烧", "喇叭", "警告", "信封", "房子", "礼物", "点赞", "举手", "喝彩", "点头",
	"摇头", "偷瞄", "庆祝", "疾跑", "打滚", "惊吓", "起跳"
];

let transform = (content) => {
	// Old #汉字; format → map to corresponding unicode emoji
	let result = content.replace(/\#[一-龥]{1,3}\;/gi, (emoText) => {
		let word = emoText.replace(/\#|\;/gi, '');
		let idx = oldEmoTextList.indexOf(word);
		if (idx === -1 || idx >= emoTextList.length) return emoText;
		return emoTextList[idx];
	});
	// #unicode; format (e.g. "#😀;") → bare unicode char
	emoTextList.forEach((emo) => {
		result = result.split(`#${emo};`).join(emo);
	});
	return result;
}

let textToImg = (emoText) => {
	return transform(emoText);
}

let textToUrl = () => '';

export default {
	emoTextList,
	oldEmoTextList,
	transform,
	textToImg,
	textToUrl
}
